// Override Settings
var bcSfSearchSettings = {
  search: {
    // suggestionMode: 'test',
    // suggestionPosition: 'left'
  }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
  // adding custom close button to suggestions
  suggestionElement.append('<button type="button" class="bc-sf-search-btn-close-suggestion--desktop" onclick="closeSearch(\''+ searchBoxId +'\');"></button>')
};

// Build number of Search result
// BCSfFilter.prototype.buildSearchResultNumber = function(data) {
//   var content = '';
//   var searchTerm = this.escape(this.getSearchTerm());
//   if (searchTerm != null) {
//       var content = bcSfFilterConfig.label.search_result_number_other;
//       if (data.total_product <= 1) {
//           var content = bcSfFilterConfig.label.search_result_number_one;
//       }
//       content = content.replace(/{{ count }}/g, data.total_product).replace(/{{ terms }}/g, searchTerm);
//   }
//   jQ('.' + this.class.searchResultNumber).html(content);
// };

BCSfFilter.prototype.buildSuggestionProductList = function(a, b, c, d, e) {
  var f = "";

  f += this.buildSuggestionHeader(d.label, "product");

  var g = this.buildSuggestionDidYouMean(a, e, c);

  if ("" != g && (f += '<li class="' + this.class.searchSuggestionItem + ' bc-sf-search-suggestion-dym" aria-label="Did you mean">' + g + "</li>"), Object.keys(b).length > 0)
      for (var h = 0, i = 0; i < b.length && h < d.number; i++) {
          var j = b[i]
          var k = this.customizeSuggetionProductTitle(j.title, a, b);

          k = this.highlightSuggestionResult(k, a);

          var l = this.buildProductItemUrl(j, !1);
          var m = j.images_info.length > 0 ? this.optimizeImage(j.images_info[0].src, "200x") : bcSfFilterConfig.general.no_image_url;
          var n = null !== j.skus && j.skus.length > 0 ? j.skus[0] : "";
          var o = this.class.searchSuggestion;
          var p = this.getSettingValue("search.openProductNewTab") ? 'target="_blank"' : "";

          // Fix for free items from SECOAPP being listed as $0.00
          var priceDisplay = this.buildSuggestionProductPrice(j)
          if(priceDisplay.indexOf(`>$0.00</`) >= 0) {
            var nonFreeItemPrice = j.variants.map(item => parseFloat(item.price)).reduce((minVal, currentVal) => {
              if(minVal <= 0.0 && currentVal > minVal) {
                return currentVal;
              }
              return currentVal < minVal && currentVal > 0.0 ? currentVal : minVal;
            });
            priceDisplay = priceDisplay.replace(`>$0.00</`, `>${this.formatMoney(nonFreeItemPrice * 100)}</`);
          }

          const snippet = this.getProductMetafield(j, 'accentuate', 'snippet')
          // console.log('product', j)
          console.log('snippetz', snippet)
          // console.log('this.getProductMetafield', this.getProductMetafield)

          f += '<li class="' + this.class.searchSuggestionItem + " " + this.class.searchSuggestionItem + '-product" aria-label="' + this.escape(d.label) + ": " + this.escape(j.title) + '">',
          f += '<a href="' + l + '" ' + p + ">", this.getSettingValue("search.showSuggestionProductImage") && (f += '<div class="' + o + '-left image__bg"><span class="image__bg-gradient cover"></span><img src="' + m + '" /></div>'),
          f += '<div class="' + o + '-right">',
          n && this.getSettingValue("search.showSuggestionProductSku") && (f += '<div class="' + o + '-product-sku">SKU: ' + n + "</div>"),
          this.getSettingValue("search.showSuggestionProductVendor") && (f+='<div class="'+o+'-product-vendor">' + j.vendor + "</div>"),
          f += '<div class="' + o + '-product-title">' + k + "</div>",
          // (f += '<div class="' + o + '-product-type">' + j.product_type + "</div>"),
          snippet !== null && (f += '<div class="' + o + '-product-snippet">' + this.getProductMetafield(j, 'accentuate', 'snippet') + "</div>"),
          f += priceDisplay,
          f += "</div>",
          f += "</a>",
          f += "</li>",
          h++
      }
  return f
}

BCSfFilter.prototype.showSuggestionLoading = function(a, b) {
  console.log('BCSfFilter.prototype.showSuggestionLoading()')
  if (window.matchMedia('(min-width: 1024px)').matches && b !== '#bc-sf-search-box-2') {
    // jQ('[data-search-overlay="desktop"]').addClass('active')
  }

  var c = this;
  if (this.getSettingValue("search.showSuggestionLoading")) {
    jQ(a).children().hide();
    var d = this.class.searchSuggestionLoading;
    if (0 == jQ("." + d).length) {
      this.buildSuggestionWrapper(a, b);
      var e = d + "-img"
        , f = '<li class="' + d + '"><ul><li><div class="' + e + '"></div></li><li><div class="' + e + '"></div></li><li><div class="' + e + '"></div></li></ul></li>';
      if (jQ(a).prepend(f),
      jQ(a).show(),
      !c.isSuggestionStyle2()) {
        var g = this.getSuggestionWidth(b);
        jQ(a).outerWidth(g);
        var h = getSuggestionPosition(b)
          , i = this.checkIsFullWidthSuggestionMobile(b) ? "top" : "top+12";
        "left" == h ? jQ(a).position({
          my: "left " + i,
          at: "left bottom",
          of: jQ(b)[0]
        }) : jQ(a).position({
          my: "right " + i,
          at: "right bottom",
          of: jQ(b)[0]
        })
      }
    }
    jQ("." + d).show()
  }
}

// close mobile search when clicking on background overlay
jQ('body').on('click', '.bc-sf-search-suggestion-mobile-top-panel', function(e) {
  const inForm = jQ(e.target).closest('form').length > 0

  // If clicking the site overlay, close search
  if (!inForm) {
    const a = '#bc-sf-search-box-mobile'
    const b = true
    jQ(a).autocomplete("close"),
    jQ("." + bcsffilter.class.searchSuggestion + '[data-search-box="' + a + '"]').parent().hide();
    b && jQ(".bc-sf-search-suggestion-mobile-top-panel").hide(),
    setValueAllSearchBoxes(),
    jQ(".bc-sf-search-no-tabindex").attr("tabindex", -1),
    jQ("body").removeClass("bc-sf-search-suggestion-mobile-open"),
    bcsffilter.afterCloseSuggestionMobile(a, b)
  }
})

function closeSearch(a) {
  console.log('closeSearch(a)', a)
  jQ('[data-search-box="' + a + '"]').blur()
  jQ('[data-search-overlay="desktop"]').removeClass('active')
}


/* Start Search Redirect */
function submitSearchFormMobile(t,e){e.preventDefault();var o=bcsffilter.getSearchRedirectUrl(bcsffilter.currentTerm);o?window.location.href=o:jQ(t).closest("form").submit()}function beforeSubmitSearchForm(t,e){var o=jQ(t).val(),i=bcsffilter.getSearchRedirectUrl(o);i&&(e.stopImmediatePropagation(),e.stopPropagation(),e.preventDefault(),window.location.href=i)}BCSfFilter.prototype.setSuggestionPosition=function(t){var e=this;if("function"==typeof getSuggestionPosition&&"function"==typeof this.checkIsFullWidthSuggestionMobile){var o=getSuggestionPosition(t),i=this.checkIsFullWidthSuggestionMobile(t)?"top":"top+12";"function"!=typeof e.isSuggestionStyle2||e.isSuggestionStyle2(),"left"==o?jQ(t).autocomplete("option","position",{my:"left "+i,at:"left bottom",collision:"none"}):jQ(t).autocomplete("option","position",{my:"right "+i,at:"right bottom",collision:"none"})}else"left"==this.getSettingValue("search.suggestionPosition")?jQ(t).autocomplete("option","position",{my:"left top+12",at:"left bottom",collision:"none"}):jQ(t).autocomplete("option","position",{my:"right top+12",at:"right bottom",collision:"none"});if(jQ(t).length>0&&jQ(t).on("keydown",function(o){13==o.keyCode&&e.enterSearchBoxEvent(t,o)}),jQ(t).closest("form").length>0){var n=jQ(t).closest("form").find('[type="submit"]');n&&n.length>0&&n.each(function(e,o){o.setAttribute("onclick","beforeSubmitSearchForm('"+t+"', event)")})}},BCSfFilter.prototype.enterSearchBoxEvent=function(t,e){var o=jQ(t).val(),i=this.getSearchRedirectUrl(o);i&&(e.preventDefault(),window.location.href=i)},BCSfFilter.prototype.getSearchRedirectUrl=function(t){if(this.suggestionCache&&this.suggestionCache.hasOwnProperty(t))for(var e=this.suggestionCache[t],o=0;o<e.length;o++)if("redirect"==e[o].key&&e[o].values){var i=e[o].values;return i=(i=i.replace("https://"+bcSfFilterMainConfig.shop.domain,"")).replace("http://"+bcSfFilterMainConfig.shop.domain,"")}return""};
/* End Search Redirect */
